// noinspection JSUnusedLocalSymbols,JSUnresolvedVariable

/**
 * Contains analytics collection JS routines.
 *
 * @package Swan
 */
'use strict'

/**
 * Function to extract product ID from body class.
 *
 * @return {Number|null}
 */
function extractProductIdFromBodyClass() {
	let productId
	for ( const className of document.body.classList ) {
		if ( /postid-\d+$/.test( className ) ) {
			productId = className.replace( 'postid-', '' );
			break;
		}
	}
	return productId ? parseInt( productId ) : null;
}

window.addEventListener( 'load', function() {
	setTimeout( initializeAnalytics, 1000 );

	function initializeAnalytics() {
		const pageWrapper = document.getElementById( 'wrapper' );

		Object.assign(
			swanAnalytics,
			{
				/**
				 * Checks if the element is in the viewport.
				 *
				 * @param {Element} element        Element of which to check the visibility.
				 * @param {Number}  percentVisible How many percents are visible, from 0 to 1.
				 *
				 * @return {Boolean} If the element is in viewport.
				 *
				 * @see https://stackoverflow.com/a/51121566
				 */
				isElementInViewport( element, percentVisible = 100 ) {
					const rect = element.getBoundingClientRect();
					const windowHeight = ( window.innerHeight || document.documentElement.clientHeight );

					const topVisibility    = Math.floor(100 - ( ( ( rect.top >= 0 ? 0 : rect.top ) / +- rect.height) * 100 ) );
					const bottomVisibility = Math.floor(100 - ( ( rect.bottom - windowHeight ) / rect.height) * 100 );

					return !! topVisibility &&  // Not NaN (element is visible).
					       (
					       topVisibility > percentVisible &&
					       bottomVisibility > percentVisible
					       );
				},

				/**
				 * Sends the data to the server.
				 *
				 * Uses Beacon API if available and data size is less than 64KB, and otherwise fallbacks to AJAX.
				 *
				 * @param {Object} dataObject Data object.
				 */
				sendData( dataObject ) {
					const data = new URLSearchParams( dataObject )

					const beaconLimit= 64000 // 64KB (not KiB) - just in case.
					const dataString   = data.toString()
					const dataSize   = new Blob( [ dataString ] ).size

					if ( navigator.sendBeacon && dataSize < beaconLimit ) {
						const beaconSent = navigator.sendBeacon( swanAnalytics.ajaxurl, data )
						if ( beaconSent ) {
							// Beacon API succeeded, no need to use AJAX.
							return
						}
					}

					// If we reached here, either Beacon API is not available or it failed or data size was too large.
					// Fall back to AJAX.
					let params = {
						method: 'POST',
						credentials: 'same-origin',
						headers: new Headers( { 'Content-Type': 'application/x-www-form-urlencoded' } ),
						body: data,
					}

					fetch( swanAnalytics.ajaxurl, params ).then( response => {
						return response.json()
					} ).then( response => {
						if ( true !== response.success ) {
							console.error( "Swan: Wasn't able to track the data" )
						}
					} )
				},
			}
		);

		/**
		 * Single product page.
		 */
		if ( document.body.classList.contains( 'single-product' ) ) {
			const formCart = document.querySelector( 'form.cart' );

			if ( formCart ) {
				formCart.addEventListener( 'submit', function ( event ) {
					const productId = extractProductIdFromBodyClass()

					const qtyInput = pageWrapper.querySelector( 'input[name="quantity"]' );

					if ( productId ) {
						swanAnalytics.sendData( {
							action:    'swan_track_product_added_to_cart',
							productId: productId,
							qty:       qtyInput ? qtyInput.value : 1,
						} )
					}
				} )
			}
		}

		/**
		 * When adding a product in the catalog.
		 */

		const addToCartElements = document.querySelectorAll( '.ajax_add_to_cart' );

		addToCartElements.forEach( addToCartElement => {
			addToCartElement.addEventListener(
				'click',
				function( e ) {
					const productID = addToCartElement.getAttribute( 'data-product_id' );

					if ( productID ) {
						swanAnalytics.sendData( {
							action:    'swan_track_product_added_to_cart',
							productId: productID,
							qty:       1,
						} )
					}
				}
			);
		} );

		/**
		 * Viewed products during the catalog navigation.
		 *
		 * @type {Number[]}
		 */
		swanAnalytics.viewedProducts = [];

		// Setup Intersection Observer
		const observerOptions = {
			root: null, // observing for viewport
			rootMargin: '0px',
			threshold: 0.05 // Adjust threshold to when 5% of the item is visible
		};

		const observer = new IntersectionObserver( ( entries, observer ) => {
			entries.forEach( entry => {
				if ( entry.isIntersecting && entry.intersectionRatio >= 0.05 ) {
					const productId = parseInt( entry.target.getAttribute( 'swan-analytics-data-product-id' ) )
					if ( productId && swanAnalytics.viewedProducts.indexOf( productId ) === - 1 ) {
						swanAnalytics.viewedProducts.push( productId );
						observer.unobserve( entry.target ); // Stop observing the product once it has been logged
					}
				}
			} )
		}, observerOptions );

		( function populateCatalogViewedProducts() {
			if ( document.body.classList.contains( 'single-product' ) ) { // Do not populate catalog viewed products for single product.
				return;
			}

			if ( ! pageWrapper ) { // Some templates (e.g. the checkout's distraction-free layout) render without #wrapper.
				return;
			}

			const classPrefix     = 'post-';
			const productSelector = `.speedsearch-single-post[class*="${classPrefix}"]`;

			/**
			 * The list of post classes to ignore, which aren't considered real posts.
			 *
			 * For example, contains placeholder posts.
			 *
			 * @type {String[]}
			 */
			const POST_CLASSES_TO_IGNORE = [
				'speedsearch-placeholder-post', // Saffy preloader post.
			];

			/**
			 * Adds product to tracking.
			 *
			 * Also handles them by adding 'swan-analytics-data-product-id' to attribute to faster access the product ID.
			 *
			 * On initial loading, and on DOM modification (when there is a chance that a new product has been added).
			 */
			( function addProductsToTrack() {
				/**
				 * Add product ID attribute to the product.
				 *
				 * @param product
				 */
				function handleAProductForTracking( product ) {
					if ( product.hasAttribute( 'swan-analytics-data-product-id' ) ) { // Bail if this product is already being tracked.
						return;
					}

					for ( const postClassToIgnore of POST_CLASSES_TO_IGNORE ) {
						if ( product.classList.contains( postClassToIgnore ) ) {
							return;
						}
					}

					let productId;
					for ( const className of product.classList ) { // Get the product ID from the classes.
						if ( className.startsWith( classPrefix ) ) {
							productId = className.replace( classPrefix, '' );

							if ( /^\d+$/.test( productId ) ) { // Only digits.
								productId = parseInt( productId );
								break;
							}
						}
					}

					if ( ! productId ) {
						return;
					}

					product.setAttribute( 'swan-analytics-data-product-id', productId );
					observer.observe( product ); // Start observing the product.
				}

				const products = pageWrapper.querySelectorAll( productSelector );
				for ( const product of products ) {
					handleAProductForTracking( product );
				}

				// Handle a case when the products were added to the DOM after DOMContentLoaded event.

				speedsearch.hookAFuncAfterThePostsAddition(
					function() {
						const products = pageWrapper.querySelectorAll( productSelector + ':not([swan-analytics-data-product-id])' );
						for ( const product of products ) {
							handleAProductForTracking( product );
						}
					}
				);
			} ) ();
		} ) ();

		/**
		 * How many of swanAnalytics.viewedProducts have been sent.
		 *
		 * @type {Number}
		 */
		let sentViewedProducts = 0;

		/**
		 * Returns the analytics data collected since the last send.
		 *
		 * @return {Object} User data.
		 */
		function getAnalyticsData() {
			const viewedProducts = swanAnalytics.viewedProducts.slice( sentViewedProducts );
			sentViewedProducts   = swanAnalytics.viewedProducts.length;

			return {
				viewedProducts: viewedProducts,
				wishlistAdded:  window.swanWishlist ? window.swanWishlist.drainAdded() : [],
			}
		}

		/**
		 * If BF cache is present.
		 *
		 * @type {null|Boolean}
		 */
		let bfCachePresent = null
		const navigationEntry = performance.getEntriesByType( 'navigation' )[ 0 ]
		if ( (event && event.persisted) || ( navigationEntry && 'back_forward' === navigationEntry.type ) ) {
			bfCachePresent = true;
		}

		/**
		 * Returns page load time (Based on DOMContentLoaded event).
		 *
		 * @return {Number|null} Page load time or null if the page has been closed before the loading.
		 */
		function getLoadTime() {
			if ( bfCachePresent ) {
				return 0;
			} else {
				const navigationEntry = performance.getEntriesByType( 'navigation' )[0];
				const pageLoadTime = navigationEntry ? navigationEntry.loadEventEnd : null;
				if ( pageLoadTime > 0 ) {
					return pageLoadTime / 1000;
				} else {
					return null;
				}
			}
		}

		/**
		 * Sends the analytics data collected since the last send, if there is any.
		 */
		function sendAnalyticsData() {
			const userData = getAnalyticsData();

			if ( ! userData.viewedProducts.length && ! userData.wishlistAdded.length ) {
				return;
			}

			swanAnalytics.sendData( {
				action:   'swan_analytics_data_track',
				userData: JSON.stringify( userData ),
			} );
		}

		/**
		 * Also send every minute, so a long visit loses no data if the page never gets to send on exit
		 * (a crash, a killed mobile tab).
		 */
		setInterval( function() {
			if ( null !== getLoadTime() ) {
				sendAnalyticsData();
			}
		}, 60 * 1000 );

		/**
		 * Send on exit.
		 */
		document.addEventListener( 'visibilitychange', e => {
			if ( ! e.isTrusted ) {
				return;
			}

			if ( 'hidden' === document.visibilityState ) {
				if ( null !== getLoadTime() ) { // Do not send the data for the page when it wasn't loaded.
					sendAnalyticsData();
				}
			}
		} );
		window.addEventListener( 'pagehide', e => {
			if ( ! e.isTrusted ) {
				return;
			}

			if ( null !== getLoadTime() ) { // Do not send the data for the page when it wasn't loaded.
				sendAnalyticsData();
			}
		} );

		/**
		 * Tracks single product view.
		 */
		( function trackSingleProductView() {
			if ( document.body.classList.contains( 'single-product' ) ) {
				const productId = extractProductIdFromBodyClass();

				// Make sure the product ID is a number and not null.
				if ( productId ) {
					swanAnalytics.sendData( {
						action:    'swan_track_single_product_view',
						productId: productId,
					} )
				}
			}
		} )();
	}
} );
